import styled, { css } from 'styled-components';
import { getAutomatedStyleProp } from '../../providers/ComponentsThemeProvider';
export const Container = styled.div `
  position: relative;
  display: flex;
  background: var(--bg-transparent);
  color: var(--text-primary);
  border-radius: ${getAutomatedStyleProp('inputCornerRadius', 'var(--radius-brand)')};

  a,
  button {
    font-size: inherit;
    line-height: inherit;
    text-decoration: underline;
    text-underline-offset: 1px;
  }

  ul {
    list-style: disc;
    padding-inline-start: 1.5em;
  }

  ol {
    list-style: decimal;
    padding-inline-start: 1.5em;
  }

  strong {
    font-weight: var(--font-weight-medium);
  }

  ${({ $appearance }) => $appearance === 'danger' &&
    css `
      background: var(--bg-critical-secondary);
      color: var(--text-critical-tertiary);
    `};

  ${({ $appearance }) => $appearance === 'warning' &&
    css `
      background: var(--bg-alert-secondary);
      color: var(--text-alert-tertiary);
    `};

  ${({ $appearance }) => $appearance === 'inherit' &&
    css `
      background: ${getAutomatedStyleProp('paleBackground')};
      color: ${getAutomatedStyleProp('paleTextColor')};
    `};

  ${({ $appearance }) => $appearance === 'clean' &&
    css `
      background: none;
    `};

  ${({ $appearance }) => $appearance === 'pro' &&
    css `
      background-color: var(--bg-pro);
      color: var(--text-pro);
    `};

  ${({ $size }) => $size === 'normal' &&
    css `
      padding: var(--space-300) var(--space-500);
      font-size: var(--font-size-400);
    `};

  ${({ $size }) => $size === 'small' &&
    css `
      padding: var(--space-250) var(--space-400);
      font-size: var(--font-size-300);
    `};

  ${({ $size, $withRightContent }) => $size === 'normal' &&
    $withRightContent &&
    css `
      padding-right: 52px;
    `};

  ${({ $size, $withRightContent }) => $size === 'small' &&
    $withRightContent &&
    css `
      padding-right: var(--space-1200);
    `};

  ${({ $withoutPaddings }) => $withoutPaddings &&
    css `
      padding: 0;
    `};
`;
export const Main = styled.div `
  flex: 1;
  display: flex;

  ${({ $size }) => $size === 'normal' &&
    css `
      line-height: var(--font-line-height-400);
      font-size: var(--font-size-400);
      letter-spacing: var(--font-letter-spacing-normal);
    `}

  ${({ $size }) => $size === 'small' &&
    css `
      line-height: var(--font-line-height-300);
      font-size: var(--font-size-300);
      letter-spacing: var(--font-letter-spacing-loose);
    `}

  ${({ $justify }) => $justify === 'center' &&
    css `
      justify-content: center;
    `};

  ${({ $justify }) => $justify === 'right' &&
    css `
      justify-content: flex-end;
    `};
`;
export const IconContainer = styled.div `
  position: relative;
  top: var(--space-50);
  margin-right: var(--space-400);
`;
export const Title = styled.div `
  font-size: var(--font-size-400);
  color: var(--text-primary);
`;
export const Subtitle = styled.div `
  font-size: var(--font-size-300);
  letter-spacing: var(--font-letter-spacing-loose);
  color: var(--text-secondary);
`;
export const CloseButtonContainer = styled.button `
  position: absolute;
  cursor: pointer;
  right: var(--space-500);

  ${({ $size }) => $size === 'normal' &&
    css `
      top: var(--space-400);
    `};

  ${({ $size }) => $size === 'small' &&
    css `
      top: var(--space-350);
    `};
`;
